import React from "react";

import { useParams } from "react-router";
import FiringCard from "./FiringCard";
import useFirebaseFirings from "../hooks/useFirebaseFirings";
import useFirebaseProject from "../hooks/useFirebaseProject";
import useFirebaseTemplateFirings from "../hooks/useFirebaseTemplateFirings";
import _ from "lodash";

const FiringFavouriteCreatePage = () => {
  const { id: project_id } = useParams();
  const project = useFirebaseProject(project_id!);
  const all_firings = useFirebaseFirings();
  const template_firings = useFirebaseTemplateFirings(project && project.glass as any);
  const favourite_firings = _.filter(Object.values(all_firings || {}), (firing: any) => !!firing.favourite);
  const favourite_firings_array = favourite_firings && Object.values(favourite_firings);
  const template_firings_array = template_firings && Object.values(template_firings);
  return (
    <>
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Favourite Firings</h3>
        {favourite_firings_array &&
          favourite_firings_array.map(
            (firing, index) =>
              firing && (
                <FiringCard
                  key={firing.id}
                  {...firing}
                  index={index}
                  hideIndex
                  to={`/copy_favourite_firing_confirm/${project_id}/${firing.id}`}
                />
              )
          )}
      </div>
      <div className="mb-4">
        <h3 className="text-lg font-semibold mb-2">Template Firings</h3>
        {template_firings_array &&
          template_firings_array.map(
            (firing, index) =>
              firing && (
                <FiringCard
                  key={firing.id}
                  {...firing}
                  index={index}
                  hideIndex
                  to={`/copy_template_firing_confirm/${project_id}/${firing.id}/${project?.glass}`}
                />
              )
          )}
      </div>
    </>
  );
};

export default FiringFavouriteCreatePage;
